import { useEffect, useState } from 'react';
import { serverNow } from '../../serverClock.js';

/**
 * A hora do servidor, de novo a cada `everyMs` enquanto `active`. O tique cai na virada contada a
 * partir de `anchor` (no relógio do servidor): com a âncora do jogo, o segundo do relógio vira junto
 * com o de todo mundo, sem pular nem repetir dígito como um `setInterval` solto.
 */
export function useServerNow(active: boolean, everyMs: number, anchor = 0): number {
  const [, setTick] = useState(0);
  useEffect(() => {
    if (!active) return;
    let timer = 0;
    const schedule = () => {
      const into = (((serverNow() - anchor) % everyMs) + everyMs) % everyMs;
      // um pouco depois da virada, para não cair ainda no número de antes
      timer = window.setTimeout(() => {
        setTick((n) => n + 1);
        schedule();
      }, everyMs - into + 15);
    };
    schedule();
    return () => window.clearTimeout(timer);
  }, [active, everyMs, anchor]);
  return serverNow();
}
